/* eslint-disable */
export default {
  'data': {
    "id": 61,
    "title": "04_Confer",
    "description": "",
    "language": "",
    "status": 1,
    "layerCount": "1",
    "tierCount": "1",
    "thumbnailURL": "",
    "speed": 1,
    "fov": 1.5707963267948966,
    "fullScreen": 1,
    "startingSceneID": 1485,
    "group": "ZR010",
    "type": "interior",
    "menuOrder": "",
    "minimaps": [
      {
        "id": 38,
        "url": "https://cdn.zipview.kr/webvr/service/ZR010/interior/04_Confer/minimap.jpg",
        "tier": 1,
        "tourID": 61
      }
    ],
    "scenes": [
      {
        "id": 1485,
        "title": "",
        "description": "",
        "tag": "",
        "importantPlace": 0,
        "yaw": 0,
        "pitch": 0,
        "x": 154.511993408203,
        "y": 153,
        "z": 0,
        "tier": 1,
        "compass": "",
        "offset": -1.5707700252533,
        "thumbnailURL": "https://cdn.zipview.kr/webvr/service/ZR010/interior/04_Confer/tiles/0/preview.jpg",
        "tourID": 61,
        "layers": [
          {
            "id": 1482,
            "url": "https://cdn.zipview.kr/webvr/service/ZR010/interior/04_Confer/tiles/0",
            "sceneID": 1485,
            "layerHotspots": [
              {
                "id": 5343,
                "title": "",
                "description": "",
                "descriptionEN": "",
                "yaw": 0,
                "pitch": -.139,
                "hotspotType": "embed",
                "iconImg": "",
                "category": "",
                "categoryName": "",
                "categoryNameEN": "",
                "action": {
                  "url": "https://www.youtube.com/embed/yEwoWiKnZ5c",
                  "radius": 1640,
                  "extraTransforms": "rotateX(8deg)",
                  "width": 1550,
                  "height": 870,
                },
                "layerID": 1485
              },
            ]
          }
        ]
      }
    ]
  }
}